import Styles from "./CreatePlaylist.module.scss";
import { ReactComponent as SpotifyAddIcon } from "../../../icons/extra_icons/spotify_add.svg"

const CreatePlaylist = () => {
    return (
        <div className={Styles.container}>
            <div className={Styles.main_frame}>
                <div className={Styles.icon}>
                    <SpotifyAddIcon />
                </div>
                <div className={Styles.label}>
                    Sorry, This feature is not available in this version.
                </div>
            </div>
        </div>
    )
}

export default CreatePlaylist
